import { render, staticRenderFns } from "./SelectWorkspace.vue?vue&type=template&id=7043945e&scoped=true&"
import script from "./SelectWorkspace.vue?vue&type=script&lang=js&"
export * from "./SelectWorkspace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043945e",
  null
  
)

export default component.exports